var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('fa-icon',{attrs:{"icon":"times-circle"},on:{"click":_vm.remove}}),_c('span',{staticClass:"spacer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }